import { CollectionReference, doc, DocumentReference } from '@angular/fire/firestore';
import { getCollectionRef } from '../utils/firestore.refs';
import {
  AUDIO_RESOURCES_COLLECTION,
  IMAGE_RESOLUTIONS_COLLECTION,
  IMAGE_RESOURCES_COLLECTION,
  VIDEO_RESOURCES_COLLECTION,
} from '../paths/media.path';
import { ImageResource } from '../../models/media/image-resource.model';
import { ImageResolution, ImageResolutionValue } from '../../models/media/image-resolution.model';
import { AudioResource } from '../../models/media/audio-resource';
import { VideoResource } from '../../models/media/video-resource';
import { AsyncInterviewAnswer } from '../../models/async-interview/async-interview-answer.model';
import { Organization } from '../../models/organization/organization.model';
import { JobPosting } from '../../models/job-posting/job-posting.model';
import { User } from '../../models/user/user.model';

export function getImageResourcesCol(
  parentRef: DocumentReference<User | Organization | JobPosting>
): CollectionReference<ImageResource> {
  return getCollectionRef<ImageResource>(parentRef, IMAGE_RESOURCES_COLLECTION);
}

export function getImageResolutionsCol(
  parentRef: DocumentReference<ImageResource>
): CollectionReference<ImageResolution> {
  return getCollectionRef<ImageResolution>(parentRef, IMAGE_RESOLUTIONS_COLLECTION);
}

export function getImageResolutionRef(
  parentRef: DocumentReference<ImageResource>,
  resolution: ImageResolutionValue
): DocumentReference<ImageResolution> {
  const col = getImageResolutionsCol(parentRef);
  return doc(col, resolution);
}

export function getAudioResourcesCol(
  parentRef: DocumentReference<AsyncInterviewAnswer>
): CollectionReference<AudioResource> {
  return getCollectionRef<AudioResource>(parentRef, AUDIO_RESOURCES_COLLECTION);
}

export function getVideoResourcesCol(
  parentRef: DocumentReference<AsyncInterviewAnswer>
): CollectionReference<VideoResource> {
  return getCollectionRef<VideoResource>(parentRef, VIDEO_RESOURCES_COLLECTION);
}
